/*
 * @Author: Json Chen
 * @Date: 2021-07-06 13:25:20
 * @LastEditTime: 2022-06-13 11:19:12
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCookies/Settings/index.tsx
 */
import { InfoCircleFilled, InfoCircleOutlined } from '@ant-design/icons';
import { Button, Collapse, Form, Switch } from 'antd';
import React from 'react';
// import {
//   Input,
//   Checkbox,
//   Modal,
//   ModalFooter,
// } from '@/src/components/Antd';
import ColorPicker from 'src/components/ColorPicker/ColorPicker';
import Editor from 'src/constrains/BraftEditor';
import Reset from '../Components/Reset';
import styles from '../style.module.less';
import { useParams } from 'react-router-dom';
import { CheckboxProps } from 'antd/lib/checkbox';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

type ColorPickerProps = CheckboxProps & {
  onChange?: (v: string) => void;
};

const FormColorPicker = ({
  value = '#000',
  onChange,
  disabled,
}: ColorPickerProps) => {
  return (
    <ColorPicker
      multi
      disable={disabled}
      color={value}
      onChange={(v: string) => {
        onChange(v);
      }}
    />
  );
};

const FormEditor = (props: any) => {
  const params: any = useParams();
  const uuid = params.uuid;
  const { value, onChange, disabled } = props || {};
  const onEditorChange = (e) => {
    onChange(e.data);
  };

  return (
    <Editor
      // configFront={['undo', 'redo', 'separator', 'bold', 'code']}
      data={value}
      disabled={disabled}
      onChange={onEditorChange}
      onEmpty={onEditorChange}
      salesChannelUuid={uuid}
    />
  );
};

const Settings = ({
  isOnPrimaryLanguage,
  onReset,
  onClone,
  errList = [],
  disableEdit,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const isPrimary = React.useMemo(() => {
    return isOnPrimaryLanguage;
  }, [isOnPrimaryLanguage]);
  return (
    <div className={styles.settingContainer}>
      <div className={styles.settingHeader}>
        {getI18n('salesChannelCookies.index.cookiesAcceptance')}
      </div>
      <div className={styles.settingContent}>
        <div className={styles.settingContentContainer}>
          {isOnPrimaryLanguage && (
            <Form.Item
              className={styles.settingContentSwitch}
              name={'enabled'}
              valuePropName={'checked'}
              label={getI18n(
                'salesChannelCookies.index.enableFloatingActionsBar',
              )}>
              <Switch disabled={disableEdit} />
            </Form.Item>
          )}

          {
            <Form.Item
              noStyle
              shouldUpdate={(p, c) => {
                return p.enabled !== c.enabled;
              }}>
              {({ getFieldValue }) => {
                // 获取所有字段的值
                const enabled = getFieldValue('enabled');
                return (
                  <React.Fragment>
                    {!isPrimary && enabled ? (
                      <div className={styles.cloneButtonContainer}>
                        <Button
                          type='primary'
                          disabled={disableEdit}
                          className={`${
                            disableEdit ? styles.disableCloneButton : ''
                          } ${styles.cloneButton}`}
                          onClick={onClone}>
                          {getI18n(
                            'salesChannelCookies.index.clonefromPrimaryLanguage',
                          )}
                        </Button>
                      </div>
                    ) : !isPrimary && !enabled ? (
                      <div className={styles.noCookies}>
                        <InfoCircleOutlined className={styles.noCookiesIcon} />
                        {getI18n('salesChannelCookies.index.noCookiesText')}
                      </div>
                    ) : null}

                    <Collapse
                      className={styles.settingContentCollapse}
                      expandIconPosition={'right'}
                      accordion
                      bordered={false}>
                      {isPrimary && enabled && (
                        <Collapse.Panel
                          forceRender
                          key={'Cookies Style'}
                          header={getI18n(
                            'salesChannelCookies.index.cookiesStyle',
                          )}
                          extra={<Reset onReset={onReset} />}>
                          <div className={styles.settingContentStyles}>
                            <Form.Item
                              name={'textColor'}
                              label={getI18n(
                                'salesChannelCookies.index.textColour',
                              )}>
                              <FormColorPicker disabled={disableEdit} />
                            </Form.Item>
                            <Form.Item
                              name={'backgroundColor'}
                              label={getI18n(
                                'salesChannelCookies.index.backgroundColour',
                              )}
                              initialValue={'#fff'}>
                              <FormColorPicker disabled={disableEdit} />
                            </Form.Item>
                          </div>
                        </Collapse.Panel>
                      )}

                      {enabled && (
                        <Collapse.Panel
                          header={getI18n(
                            'salesChannelCookies.index.cookiesContent',
                          )}
                          key={'Cookies Content'}
                          forceRender
                          extra={
                            errList.includes('cookieContent') && (
                              <InfoCircleFilled className={styles.iconWarn} />
                            )
                          }>
                          <Form.Item
                            name={'cookieContent'}
                            label={getI18n('salesChannelCookies.index.text')}
                            rules={[
                              {
                                required: true,
                                message: getI18n('general.fieldCannotEmpty'),
                              },
                            ]}
                            className={styles.cookieContentPanel}>
                            <FormEditor disabled={disableEdit} />
                          </Form.Item>
                        </Collapse.Panel>
                      )}
                    </Collapse>
                  </React.Fragment>
                );
              }}
            </Form.Item>
          }
        </div>
      </div>
    </div>
  );
};
export default Settings;
